import coreAPI from 'apis/core';

export const getClinicDeclinedReasons = async () => {
  const response = await coreAPI.clinicOrder.getClinicDeclinedReasons();

  return response.data.sort((a, b) => (a.reason > b.reason ? 1 : -1));
};

export const getClinicOrders = async (params) => {
  const response = await coreAPI.clinicOrder.getClinicOrders(params);

  return {
    orders: response.data,
    pagination: response.pagination,
  };
};

export const getSingleClinicOrder = async ({ orderId }) => {
  const response = await coreAPI.clinicOrder.getSingleClinicOrder({ orderId });

  return response.data[0];
};

export const getClinicOrderReplacementProducts = async ({ orderId }) => {
  const response = await coreAPI.clinicOrder.getClinicOrderReplacementProducts({ orderId });

  return response.data;
};

export const getClinicOrderStats = async (params) => {
  const response = await coreAPI.clinicOrder.getClinicOrderStats(params);

  return response.data[0];
};

export const approveClinicOrder = async (params) => {
  const response = await coreAPI.clinicOrder.approveClinicOrder(params);

  return response.data;
};

export const getClinicPrescribers = async (params) => {
  const response = await coreAPI.clinicOrder.getClinicPrescribers(params);

  return response.data;
};

export const getPharmaciesThatCanFulfil = async (params) => {
  const response = await coreAPI.clinicOrder.getPharmaciesThatCanFulfil(params);

  return response.data;
};

export default {};
